// extracted by mini-css-extract-plugin
export default {"wrapper":"NotP_wrapper__a8HRz","success":"NotP_success__z+T3m","err":"NotP_err__fv9AQ"};